import React from "react";
import StaffStdMentorCommunication from "../../components/StaffTabs/StaffViewOwnAttendance/StaffStdMentorCommunication";

const StaffStudentMentorCommunication = () => {
  return (
    <div>
      <StaffStdMentorCommunication />
    </div>
  );
};

export default StaffStudentMentorCommunication;
